import React from "react";
import "./style.scss";

const Subtab = (p) => {
  return (
    <div className="subtab-leaderboard">
      <div
        className={`rank-subtab ${p.activeSubtab == "users" ? "" : "inactive"}`}
        onClick={() => p.setActiveSubtab("users")}
      >
        <span
          className={`subtab-text ${
            p.activeSubtab == "users" ? "" : "inactive"
          }`}
        >
          All Users
        </span>
      </div>
      <div
        className={`rank-subtab ${p.activeSubtab == "users" ? "inactive" : ""}`}
        onClick={() => p.setActiveSubtab("unit")}
      >
        <span
          className={`subtab-text ${
            p.activeSubtab == "users" ? "inactive" : ""
          }`}
        >
          All Units
        </span>
      </div>
    </div>
  );
};

export default Subtab;
